const data = [
  {
    userKey: "user:users.user-lists",
    russian: "список пользователей",
    arabic: ".قوائم المستخدمين",
    english: "user lists",
  },
  {
    userKey: "user:users.user-first-name",
    russian: "имя пользователя",
    arabic: "اسم المستخدم الأول",
    english: "user first name",
  },
  {
    userKey: "user:users.user-last-name",
    russian: "фамилия пользователя",
    arabic: "اسم المستخدم الأخير",
    english: "user last name",
  },
  {
    userKey: "user:users.user-login",
    russian: "логин пользователя",
    arabic: "دخول المستخدم",
    english: "user login",
  },
  {
    userKey: "user:users.user-add-product",
    russian: "добавить продукт",
    arabic: "أضف المنتج",
    english: "add product",
  },
  {
    userKey: "user:users.user-orders-list",
    russian: "упорядоченный список",
    arabic: "قائمة الأوامر",
    english: "orders list",
  },
  {
    userKey: "user:users.user-coupon-list",
    russian: "список купонов",
    arabic: "قائمة القسائم",
    english: "coupon list",
  },
  {
    userKey: "user:users.user-new-password",
    russian: "пользователя новый пароль",
    arabic: ".مستخدم جديد كلمة مرور",
    english: "user new password",
  },
  {
    userKey: "user:users.user-reset-password",
    russian: " пароля",
    arabic: "أعد ضبط كلمة السر",
    english: "user reset password",
  },
  {
    userKey: "user:users.user-roles",
    russian: "роль пользователя",
    arabic: "أدوار المستخدم",
    english: "user roles",
  },
  {
    userKey: "user:users.user-profile-information",
    russian: "информация профиля",
    arabic: "معلومات التوصيف",
    english: "profile information",
  },
  {
    userKey: "admin:admin.button.delete",
    russian: "удалить",
    arabic: "احذف",
    english: "delete",
  },
  {
    userKey: "admin:admin.button.save",
    russian: "	спасать",
    arabic: "احفظ",
    english: "save",
  },
  {
    userKey: "edit",
    russian: "حرر",
    arabic: "редактировать",
    english: "admin:admin.button.edit",
  },
  {
    userKey: "admin:admin.tabs.general",
    russian: "главные вкладки",
    arabic: "الألسنة العامة",
    english: "general tabs",
  },
  {
    userKey: "user:users.user-reset-password",
    russian: " пароля",
    arabic: "أعد ضبط كلمة السر",
    english: "user reset password",
  },
  {
    userKey: "category:categories.physical",
    russian: "физический",
    arabic: "جسدي",
    english: "physical",
  },
  {
    userKey: "category:categories.digital",
    russian: "цифровой",
    arabic: "رقمي",
    english: "digital",
  },
  {
    userKey: "category:categories.sub.category",
    russian: "промежуточная категория",
    arabic: "الفئة الفرعيةر",
    english: "sub category",
  },
  {
    userKey: "media:media.dropzone",
    russian: "зона",
    arabic: "منطقة الإسقاط",
    english: "dropzone",
  },
];

export default data;
